
export default {
    name: "Pagination"
}
